import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import ImanageLogo from './ImanageLogo.vue'

export const imanageIntegration: PreviewIntegration = {
  id: 'imanage',
  name: 'iManage',
  description:
    'Connect your documents and emails from iManage to provide your AI with critical business context.',
  icon: ImanageLogo,
}
